/* A leading word said twice in a row, any case: "Amazon Amazon …". */
const REPEATED_LEAD = /^(\S+)\s+(?=\1(?:\s|$))/i;

/**
 * A connection label with an immediately repeated leading word said once:
 * "Amazon Amazon North America" -> "Amazon North America". Every other label
 * comes back unchanged.
 */
export const collapseRepeatedLead = (label: string) =>
  label.replace(REPEATED_LEAD, '');
